export const PROFILE = {
  ORGANIZER: 'ORGANIZER',
  STAFF: 'STAFF',
}

export const getProfileByCate = ({ profiles, category }) => profiles?.find((profile) => profile.category === category)

export const getOrganizerProfile = ({ profiles }) => getProfileByCate({ profiles, category: PROFILE.ORGANIZER })

export const getStaffProfile = ({ profiles }) => getProfileByCate({ profiles, category: PROFILE.STAFF })
